<div *ngIf="client$ | async as client">
  <div>
    <button mat-button mat-raised-button type="button" (click)="showHistory(client)">
      <span *ngIf="visible">Refresh</span>
      <span *ngIf="!visible">Show</span>
      History
    </button>
  </div>

  <div class="mat-elevation-z4" *ngIf="visible">
    <table mat-table [dataSource]="history$">

      <ng-container matColumnDef="modified_at">
        <th mat-header-cell *matHeaderCellDef>At</th>
        <td mat-cell *matCellDef="let element">{{element.modified_at | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="business_id">
        <th mat-header-cell *matHeaderCellDef>Business ID</th>
        <td mat-cell *matCellDef="let element">{{element.business_id}}</td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef>Country</th>
        <td mat-cell *matCellDef="let element">{{element.country}}</td>
      </ng-container>

      <ng-container matColumnDef="credit_limit">
        <th mat-header-cell *matHeaderCellDef>Credit Limit</th>
        <td mat-cell *matCellDef="let element">{{element.credit_limit?.limit.amount | currency:'EUR'}}</td>
      </ng-container>

      <ng-container matColumnDef="credit_limit_updated_at">
        <th mat-header-cell *matHeaderCellDef>Credit Limit Updated</th>
        <td mat-cell *matCellDef="let element">{{element.credit_limit?.checked_at | date:'short'}}</td>
      </ng-container>

      <ng-container matColumnDef="prepayment_register_checked_at">
        <th mat-header-cell *matHeaderCellDef>Prepayment Register</th>
        <td mat-cell *matCellDef="let element">{{element.prepayment_register_checked_at | date:'short'}}</td>
      </ng-container>

      <ng-container matColumnDef="aaa_rating">
        <th mat-header-cell *matHeaderCellDef>Credit Rating</th>
        <td mat-cell *matCellDef="let element">{{element.aaa_rating?.category }}</td>
      </ng-container>

      <ng-container matColumnDef="aaa_rating_updated_at">
        <th mat-header-cell *matHeaderCellDef>Credit Rating Updated</th>
        <td mat-cell *matCellDef="let element">{{element.aaa_rating?.checked_at | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="lead_provider_id">
        <th mat-header-cell *matHeaderCellDef>Lead Provider</th>
        <td mat-cell *matCellDef="let element">{{element.lead_provider_id }}</td>
      </ng-container>

      <ng-container matColumnDef="lead_source_id">
        <th mat-header-cell *matHeaderCellDef>Lead Source</th>
        <td mat-cell *matCellDef="let element">{{element.lead_source_id }}</td>
      </ng-container>

      <ng-container matColumnDef="responsible_seller_id">
        <th mat-header-cell *matHeaderCellDef>Responsible Seller</th>
        <td mat-cell *matCellDef="let element">{{element.responsible_seller }}</td>
      </ng-container>

      <ng-container matColumnDef="personal_id">
        <th mat-header-cell *matHeaderCellDef>Personal ID</th>
        <td mat-cell *matCellDef="let element">{{element.personal_id}}</td>
      </ng-container>

      <ng-container matColumnDef="invoicing_service_company_business_id">
        <th mat-header-cell *matHeaderCellDef>Invoicing Service Company Business ID</th>
        <td mat-cell *matCellDef="let element">{{element.invoicing_service_company_business_id}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" matRipple></tr>
    </table>
  </div>
</div>
